export default __webpack_public_path__ + "static/media/happy-icon.8910ae41.svg";